import { defineComponent as _defineComponent } from 'vue'
import { formatStripePrice } from "@/helpers/transformation/price";
  import dayjs from "dayjs";
  import { getInvoiceStatusClass } from "@/helpers/status";
  import { InvoiceStatus } from "@/enums/InvoiceStatus";
  import { computed, onMounted, ref } from "vue";
  import store from "@/store";
  import "tippy.js/dist/tippy.css";
  import "tippy.js/themes/light-border.css";
  import router from "@/router";

  interface FundsClearedReport {
    bankReference: string;
    description: string;
    fundsClearedDate: string;
    remitter: string;
  }

  
export default /*@__PURE__*/_defineComponent({
  __name: 'Payments',
  setup(__props, { expose: __expose }) {
  __expose();

  const loading = ref(true);
  const invoices = ref([]);

  const tooltipText = {
    in_progress:
      "Transaction authorised by purchaser. Funds are not yet cleared in the trust account.",
    funds_cleared: "Funds cleared in the trust account.",
    error: "An error occurred with this transaction.",
    refunded: "Payment refunded to purchaser.",
  };

  const estateId = computed(() => {
    return store.state.user.selectedEstateId;
  });

  const customerId = computed(() => {
    return router.currentRoute.value.params.id;
  });

  onMounted(() => {
    store
      .dispatch("activity/getInvoicesByCustomer", {
        customerId: customerId.value,
        estateId: estateId.value,
      })
      .then((res) => {
        invoices.value = res.data;
        invoices.value.forEach((item) => {
          item.showPaymentReference = false;
        });
      })
      .finally(() => {
        loading.value = false;
      });
  });

  const getTooltipText = (status: string) => {
    if (status === InvoiceStatus.IN_PROGRESS) {
      return tooltipText.in_progress;
    }

    if (status === InvoiceStatus.FUNDS_CLEARED) {
      return tooltipText.funds_cleared;
    }

    if (status === InvoiceStatus.ERROR) {
      return tooltipText.error;
    }

    if (status === InvoiceStatus.REFUNDED) {
      return tooltipText.refunded;
    }

    return "";
  };

  const checkFundsClearedReportAndStatus = (
    fundsClearedReport: FundsClearedReport,
    status: string
  ) => {
    return (
      Object.keys(fundsClearedReport).length !== 0 &&
      status === InvoiceStatus.FUNDS_CLEARED
    );
  };

const __returned__ = { loading, invoices, tooltipText, estateId, customerId, getTooltipText, checkFundsClearedReportAndStatus, get formatStripePrice() { return formatStripePrice }, get dayjs() { return dayjs }, get getInvoiceStatusClass() { return getInvoiceStatusClass }, get InvoiceStatus() { return InvoiceStatus }, computed, onMounted, ref, get store() { return store }, get router() { return router } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})